// extracted by mini-css-extract-plugin
module.exports = {"root":"SendCodeAgainButton_root__zIIpP","text":"SendCodeAgainButton_text__omZVF","timer":"SendCodeAgainButton_timer__VdbwC"};